type Context = Record<string, any>;

export class BaseLogger {
  private logFunction: (
    type: 'warn' | 'error' | 'info' | 'debug',
    message: string,
    context: Context,
    error?: Error
  ) => void;

  constructor(logFunction: BaseLogger['logFunction']) {
    this.logFunction = logFunction;
  }

  public info(message: string, context?: Context, error?: Error) {
    this.logFunction('info', message, context, error);
  }

  public warn(message: string, context?: Context, error?: Error) {
    this.logFunction('warn', message, context, error);
  }

  public error(message: string, context?: Context, error?: Error) {
    this.logFunction('error', message, context, error);
  }
  public debug(message: string, context?: Context, error?: Error) {
    this.logFunction('debug', message, context, error);
  }
}
